/**
 * Toggle the mobile footer-bar menu panel.
 */
(function() {
    function ready(fn) {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', fn);
        } else {
            fn();
        }
    }

    ready(function() {
        var toggle = document.querySelector('.jfs-handheld-menu-toggle');
        var menu = document.getElementById('jfs-handheld-menu');
        if (!toggle || !menu) return;

        var closeButton = menu.querySelector('.jfs-handheld-menu__close');
        var desktopQuery = window.matchMedia('(min-width: 768px)');

        function setOpen(open) {
            if (open && desktopQuery.matches) open = false;
            menu.hidden = !open;
            menu.classList.toggle('is-open', open);
            toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
            if (open) {
                document.body.classList.add('noscroll');
                var search = document.querySelector('.storefront-handheld-footer-bar li.search');
                if (search) search.classList.remove('active');
            } else {
                document.body.classList.remove('noscroll');
            }
        }

        function closeOnDesktop() {
            if (desktopQuery.matches) setOpen(false);
        }

        if (desktopQuery.addEventListener) {
            desktopQuery.addEventListener('change', closeOnDesktop);
        } else if (desktopQuery.addListener) {
            desktopQuery.addListener(closeOnDesktop);
        }

        toggle.addEventListener('click', function() {
            var open = toggle.getAttribute('aria-expanded') !== 'true';
            setOpen(open);
            if (open && closeButton) closeButton.focus();
        });

        if (closeButton) {
            closeButton.addEventListener('click', function() {
                setOpen(false);
                toggle.focus();
            });
        }

        menu.addEventListener('click', function(event) {
            if (event.target === menu) {
                setOpen(false);
                toggle.focus();
            }
        });

        document.addEventListener('keydown', function(event) {
            if (event.key === 'Escape' && !menu.hidden) {
                setOpen(false);
                toggle.focus();
            }
        });

        document.addEventListener('click', function(event) {
            if (!event.target.closest) return;
            if (event.target.closest('.storefront-handheld-footer-bar li.search > a')) {
                setOpen(false);
            }
        });
    });
})();
